import { UpdateCallRatingInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const UpdateCallRatingInputSchema: z.ZodType<UpdateCallRatingInput> =
  z.object({
    active: z.boolean(),
  });
